module.exports = __webpack_public_path__ + "img/9788901089584.249d4445.jpg";